export default __webpack_public_path__ + "static/media/EU-Taxonomy.26a1229a.svg";